import { takeEvery, put, delay } from 'redux-saga/effects';

import { dequeueNotification, enqueueNotification } from './actions';
import { ADD_TOAST_NOTIFICATION } from './actionTypes';

function* addToastToNotificationsSaga(action) {
  yield put(enqueueNotification(action.payload));
  yield delay(100);
  yield put(dequeueNotification());
}

export function* notificationsSagas() {
  yield takeEvery(ADD_TOAST_NOTIFICATION, addToastToNotificationsSaga);
}
